// @ts-nocheck

import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Form, notification, Input, Modal } from 'antd';
import { changeConfirmModalProps, resetConfirmModalProps } from '../../../redux/actions/global';

const ConfirmModal = () => {
    const dispatch = useDispatch();

    const {
        isVisible,
        shouldRefresh,
        successCallback,
        title,
        placeholder,
        successMessage,
        failMessage,
        cancelCallback,
    } = useSelector(state => state.global.confirmModalProps);

    const [submitting, setSubmitting] = useState(false);

    const onFormFinish = async values => {
        setSubmitting(true);

        const response = await successCallback(values);

        if (!response?.success) {
            notification.error({ message: response.errors?.[0]?.reason || failMessage });
        } else {
            notification.success({ message: successMessage });
            dispatch(changeConfirmModalProps({ isConfirmed: shouldRefresh }));
        }

        setSubmitting(false);

        dispatch(resetConfirmModalProps());
    };

    const onCancelClick = () => {
        cancelCallback();
    };

    return (
        <Modal
            centered
            title={title}
            visible={isVisible}
            onCancel={onCancelClick}
            okText={'Confirm'}
            okButtonProps={{
                form: 'confirmation-modal-form',
                htmlType: 'submit',
                loading: submitting,
            }}
            destroyOnClose
        >
            <Form id={'confirmation-modal-form'} onFinish={onFormFinish}>
                <Form.Item
                    name={'commentByUser'}
                    className={'m-b-0'}
                    rules={[{ required: true, message: 'Comment is required' }]}
                >
                    <Input.TextArea placeholder={placeholder ?? 'Please enter your comment'} rows={10} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ConfirmModal;
